'use strict';

export const StatusColors = [
  '#3cb878', /* Approved */
  '#000', /* Submitted */
  '#F4242C', /* Rejection */
  '#FF9800', /* In Progress */
  '#0BA0C5', /* Pending */
  '#888', /* Cancelled */
];



// WEBPACK FOOTER //
// ./src/js/projects/components/StatusChart/status-colors.js